<template>
  <div v-if="visible" class="global-spinner">
    <b-spinner variant="primary" label="Loading..."></b-spinner>
  </div>
</template>

<script>
export default {
  name: "GlobalSpinner",
  props: {
    visible: { type: Boolean, default: false }
  }
};
</script>

<style>
.global-spinner {
  position: fixed;
  top: 0; left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.7);
  z-index: 2000;
}
</style>
